export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#040404] border-t border-[#C9A84C]/10 py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center lg:items-start justify-between gap-10">
          {/* Brand */}
          <div className="flex flex-col items-center lg:items-start gap-4">
            <a href="https://emcalu.com" target="_blank" rel="nofollow noreferrer">
              <img
                src="https://static.readdy.ai/image/26eb07eb1cfab8d1c82bf00206f32d1a/ce704c1a72b5bb712287fdfe1137d609.png"
                alt="EmCaLu AI Agency"
                className="h-12 w-auto object-contain"
              />
            </a>
            <p className="text-white/30 text-xs font-light font-['Outfit'] tracking-widest uppercase text-center lg:text-left">
              AI-powered market expansion for Eastern Europe
            </p>
          </div>

          {/* Center: tagline */}
          <div className="text-center">
            <p className="font-['Cormorant_Garamond'] text-xl font-light text-white/50 italic">
              Enter. Grow. Dominate.
            </p>
            <div className="flex items-center justify-center gap-3 mt-3">
              <div className="w-8 h-px bg-[#C9A84C]/30" />
              <span className="text-[#C9A84C]/40 text-xs tracking-widest uppercase font-light font-['Outfit']">
                Romania · Moldova · CEE
              </span>
              <div className="w-8 h-px bg-[#C9A84C]/30" />
            </div>
          </div>

          {/* Right: contact */}
          <div className="flex flex-col items-center lg:items-end gap-4">
            <a
              href="mailto:alex@emcalu.com"
              rel="nofollow"
              className="flex items-center gap-2 text-white/40 hover:text-[#C9A84C] transition-colors duration-300 text-sm font-light font-['Outfit'] cursor-pointer"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-mail-line text-base" />
              </div>
              alex@emcalu.com
            </a>
            <a
              href="https://emcalu.com"
              target="_blank"
              rel="nofollow noreferrer"
              className="flex items-center gap-2 text-white/40 hover:text-[#C9A84C] transition-colors duration-300 text-sm font-light font-['Outfit'] cursor-pointer"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-global-line text-base" />
              </div>
              emcalu.com
            </a>
            <a
              href="https://www.linkedin.com/company/109861916/admin/dashboard/"
              target="_blank"
              rel="nofollow noreferrer"
              className="flex items-center gap-2 text-white/40 hover:text-[#C9A84C] transition-colors duration-300 text-sm font-light font-['Outfit'] cursor-pointer"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-linkedin-line text-base" />
              </div>
              LinkedIn
            </a>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-[#C9A84C]/8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/20 text-xs font-light font-['Outfit']">
            © {currentYear} EmCaLu AI Agency. All rights reserved.
          </p>
          <p className="text-white/15 text-xs font-light font-['Outfit'] tracking-wider uppercase">
            B2B Sales · AI Systems · Eastern Europe
          </p>
        </div>
      </div>
    </footer>
  );
}
